export default "__VITE_ASSET__DEcBfrDE__"